import { Modal, Typography } from '@getsynapse/design-system';
import intl from 'react-intl-universal';
import { useDispatch } from 'react-redux';
import { updateProgram } from 'state/Program/programSlice';
import unarchiveIcon from 'assets/icons/unarchive.svg';

type UnarchiveProgramModalProps = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  programId: string;
};

const UnarchiveProgramModal = ({
  isOpen,
  setIsOpen,
  programId,
}: UnarchiveProgramModalProps) => {
  const dispatch = useDispatch();
  const title = intl.get('PROGRAM_PAGE.UNARCHIVE_PROGRAM_MODAL.TITLE');

  const handleClose = () => setIsOpen(false);

  const handleUnarchiveProgram = async () => {
    handleClose();
    await dispatch(
      updateProgram({
        programId,
        updateFields: { is_archived: false },
      })
    );
  };

  return (
    <Modal
      aria-label={title}
      closeModal={handleClose}
      isOpen={isOpen}
      title={title}
      size='small'
      data-testid='unarchive-program-modal'
      titleIcon={{
        src: unarchiveIcon,
        className: 'text-primary-dark h-5 w-5',
      }}
      actionButtons={[
        {
          children: intl.get(
            'PROGRAM_PAGE.UNARCHIVE_PROGRAM_MODAL.UNARCHIVE_BUTTON'
          ),
          onClick: handleUnarchiveProgram,
          variant: 'primary',
          'data-cy': 'modal-unarchive-program-button',
          className: 'h-10',
        },
        {
          children: intl.get('CANCEL'),
          onClick: handleClose,
          variant: 'tertiary',
          'data-cy': 'cancel-unarchive-program-button',
          className: 'h-10',
        },
      ]}
      childrenClassName='p-0'
    >
      <Typography className='mb-6'>
        {intl.get('PROGRAM_PAGE.UNARCHIVE_PROGRAM_MODAL.BODY')}
      </Typography>
    </Modal>
  );
};

export default UnarchiveProgramModal;
